// extracted by mini-css-extract-plugin
export default {"sectionList":"SectionList_sectionList__hwHvH"};